import React, { useEffect, useState } from "react";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { Months } from "./Months";
import { CreditInterface, CreditMonthsInterface } from "../../interfaces/credit/credit.interface";
import { setCredit, setMonth } from "../../stores/credit/credit.reducer";
import { Prepaid } from "./Prepaid";
import { useCreditSelector } from "../../stores/product/product.store";

interface CreditsProps {}

export const Credits: React.FC<CreditsProps> = () => {
    const dispatch = useCreditDispatch();
    const credits = useCreditSelector((state: CreditState) => state.credits);
    const selectCredit = useCreditSelector((state: CreditState) => state.selectCredit);

    const [showed, setShowed] = useState<number>(selectCredit ? selectCredit.id : 0);

    useEffect(() => {
          setShowed(selectCredit?.id || 0);
    }, [selectCredit]);

    const changeCredit = (credit: CreditInterface) => {
        dispatch(setCredit(credit));
        setShowed(credit.id);
    };

    const onChangeMonth = (credit: CreditInterface, month: CreditMonthsInterface) => {
        dispatch(setMonth({ credit, month }));
    }

    return (
        <div className="w-full bg-white rounded-2xl">
            <div className="flex w-full justify-between">
                { credits.map(credit => (
                    <p
                        className={ `${
                            showed === credit.id
                                ? "text-white bg-dark-gray"
                                : "text-dark-gray"
                        } rounded-t-xl flex-1 text-center p-2.5 cursor-pointer font-semibold` }
                        key={ credit.id }
                        onClick={ () => changeCredit(credit) }
                    >
                        { credit.name }
                    </p>
                )) }
            </div>
            <div className="bg-dark-gray p-4 rounded-b-2xl">
                { credits.map(credit => (
                    showed === credit.id &&
                    <Months key={ credit.id } months={ credit.months } onChangeMonth={ onChangeMonth }
                            credit={ credit }/>
                )) }
            </div>
            <div className="p-4">
                <Prepaid />
            </div>
        </div>
    );
};
